document.addEventListener('DOMContentLoaded', () => {
    console.log('[WhatsApp Tracking] Initializing...');
    
    // =============================================
    // 1. Configuration & Constants
    // =============================================
    const whatsappNumber = '918591116455';
    const trackingEndpoint = 'https://alchemane-utm-whatsapp-tracker-v1-243580970370.asia-south1.run.app/store-click';
    const defaultMessage = 'Hi!';
    const MAX_RETRIES = 8;
    const POLL_INTERVAL = 250;

    // =============================================
    // 2. Enhanced Parameter Handling
    // =============================================
    const getParam = (names) => {
        const params = new URLSearchParams(window.location.search);
        
        console.log('[WhatsApp Tracking] Checking params for:', names);
        
        for (const name of names) {
            const variations = [
                name,
                name.toLowerCase(),
                name.replace(/ /g, '_'),
                name.replace(/_/g, ' ')
            ];
            
            for (const variant of variations) {
                const value = params.get(variant);
                if (value) {
                    console.log(`[WhatsApp Tracking] Found param ${variant}: ${value}`);
                    return decodeURIComponent(value);
                }
            }
        }
        return '';
    };

    // =============================================
    // 3. Tracking Data Construction
    // =============================================
    function buildTrackingData(sessionId) {
        const data = {
            website: 'alchemane', // Critical identifier for backend
            source: getParam(['Campaign Source', 'utm_source', 'site_source_name']) || 'facebook',
            medium: getParam(['Ad Set Name', 'utm_medium', 'adset.name']) || 'fb_ads',
            campaign: getParam(['Campaign Name', 'utm_campaign', 'campaign.name']) || 'unknown',
            content: getParam(['Ad Name', 'utm_content', 'ad.name']) || 'unknown',
            placement: getParam(['Placement', 'utm_placement']) || 'unknown',
            gallabox_id: getParam(['gbx_id', 'gallabox_contact']),
            original_params: Object.fromEntries(new URLSearchParams(window.location.search)),
            session_id: sessionId,
            full_url: window.location.href,
            click_time: new Date().toISOString()
        };
        
        console.log('[WhatsApp Tracking] Built tracking data:', data);
        return data;
    }

    // =============================================
    // 4. Click Handler
    // =============================================
    async function handleWhatsAppClick(e) {
        console.log('[WhatsApp Tracking] Click detected');
        e.preventDefault();
        e.stopPropagation();

        const sessionId = `wa-${Date.now()}-${crypto.randomUUID().slice(0, 8)}`;
        const utmData = buildTrackingData(sessionId);

        try {
            console.log('[WhatsApp Tracking] Sending to endpoint:', trackingEndpoint);
            const response = await fetch(trackingEndpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(utmData)
            });

            if (!response.ok) {
                console.error('[WhatsApp Tracking] Server response error:', response.status);
                throw new Error(`HTTP error ${response.status}`);
            }

            const contextData = {
                session_id: sessionId,
                source: utmData.source,
                medium: utmData.medium,
                campaign: utmData.campaign,
                placement: utmData.placement,
                click_time: utmData.click_time,
                website: 'alchemane'
            };

            const encodedContext = btoa(JSON.stringify(contextData));
            console.log('[WhatsApp Tracking] Context encoded:', encodedContext);
            
            window.open(
                `https://api.whatsapp.com/send/?phone=${whatsappNumber}` +
                `&text=${encodeURIComponent(defaultMessage)}` +
                `&context=${encodedContext}`,
                '_blank'
            );

        } catch (error) {
            console.error('[WhatsApp Tracking] Tracking failed:', error);
            window.open(`https://api.whatsapp.com/send/?phone=${whatsappNumber}`, '_blank');
        }
    }

    // =============================================
    // 5. Event Binding
    // =============================================
    function attachHandler(button) {
        if (button && !button.dataset.trackingAttached) {
            console.log('[WhatsApp Tracking] Attaching to button:', button);
            button.addEventListener('click', handleWhatsAppClick);
            button.dataset.trackingAttached = "true";
        }
    }

    // Immediate binding
    const whatsappButton = document.querySelector('#whatsapp-tracker');
    if (whatsappButton) {
        console.log('[WhatsApp Tracking] Found initial button');
        attachHandler(whatsappButton);
    } else {
        console.warn('[WhatsApp Tracking] Initial button not found');
    }

    // MutationObserver for dynamic content
    const observer = new MutationObserver(mutations => {
        console.log('[WhatsApp Tracking] DOM mutation observed');
        mutations.forEach(({ addedNodes }) => {
            addedNodes.forEach(node => {
                if (node.matches && node.matches('#whatsapp-tracker')) {
                    attachHandler(node);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    console.log('[WhatsApp Tracking] Initialization complete');
});